import api from '@/axios'

export default {
  findAll () {
    return api().get('user')
  },
  findOne (id) {
    return api().get(`user/${id}`)
  }
}
